export const ArrowDown = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.4156 18.2914L16.0054 27.589L6.68604 18.3249" stroke="currentColor" stroke-width="2"/>
<path d="M16 5V27" stroke="currentColor" stroke-width="2"/>
</svg>`;
